export default __webpack_public_path__ + "static/media/13m.020b98ca.png";